<template>
  <div>
    <panel title="Klubski popusti" collapsable>
      <template v-slot:actions>
        <el-button
          v-if="user.isAdmin"
          type="primary"
          icon="el-icon-plus"
          size="medium"
          circle
          @click="openManageDeduction = true"
        />
      </template>

      <club-deductions-table
        :data="clubDeductions"
        @edit="openEdit($event)"
        @delete="onDelete($event)"
      />
    </panel>

    <manage-seminar-club-cost-deduction
      v-if="openManageDeduction"
      :seminar="seminar"
      :club-deduction="editing"
      @edit="onEdit($event)"
      @add="onAdd($event)"
      @close="close()"
    />
  </div>
</template>

<script>
import errorHandler from '@/common/errorHandler.js'
import ClubDeductionsTable from '@/components/tournaments/ClubDeductionsTable'
import ManageSeminarClubCostDeduction from './ManageSeminarClubCostDeduction'

export default {
  components: {
    ClubDeductionsTable,
    ManageSeminarClubCostDeduction
  },

  props: {
    seminar: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      editing: null,
      openManageDeduction: false
    }
  },

  computed: {
    clubDeductions () {
      return this.seminar.clubDeductions || []
    },

    user () {
      return this.$store.state.auth.user
    }
  },

  methods: {
    openEdit (deduction) {
      this.editing = deduction
      this.openManageDeduction = true
    },

    async onDelete (deduction) {
      const loading = this.$loading()
      try {
        await this.$store.dispatch('seminarClubDeductions/delete', deduction.id)
        this.$store.commit('seminars/removeClubDeduction', { seminar: this.seminar, id: deduction.id })
        this.$message.success(this.$tc('messages.success_deleted_club_deduction'))
      } catch (e) {
        errorHandler(e)
      } finally {
        loading.close()
      }
    },

    onAdd (deduction) {
      this.$store.commit('seminars/addClubDeduction', { seminar: this.seminar, deduction })
      this.close()
    },

    onEdit (deduction) {
      this.$store.commit('seminars/updateClubDeduction', { seminar: this.seminar, deduction })
      this.close()
    },

    close () {
      this.editing = null
      this.openManageDeduction = false
    }
  }
}
</script>
